import { Text, View } from "@react-pdf/renderer";
import { styles } from "./ReactPdfStyles";
import dayjs from "dayjs";

type IndividualApprovalRecordSectionTypes = {
	generated_by: string;
	generated_at: string;
};

function IndividualApprovalRecordSection({
	data,
}: {
	data: IndividualApprovalRecordSectionTypes;
}) {
	return (
		<View style={[styles.section, styles.tableFontSize]} wrap={false}>
			<Text style={styles.tableHeader}>Approval record</Text>

			<View style={[styles.row, styles.borderRight]}>
				<View style={[styles.row, { flex: 2 }]}>
					<Text style={styles.labelCell}>Report generated on</Text>
					<Text style={styles.valueCell}>
						{dayjs(data.generated_at).format("DD MMM YYYY HH:mm:ss [UTC]")}
					</Text>
				</View>
				<View style={{ flex: 2 }}>
					<View style={[styles.row]}>
						<Text style={styles.labelCell}>Authorised by</Text>
						<Text style={styles.valueCell}></Text>
					</View>
					<View style={[styles.row, { height: 50 }]}>
						<Text style={styles.labelCell}>Signature</Text>
						<Text style={styles.valueCell}></Text>
					</View>
					<View style={[styles.row, { height: 50 }]}>
						<Text style={styles.labelCell}>Name (Block Caps)</Text>
						<Text style={styles.valueCell}></Text>
					</View>
				</View>
			</View>
		</View>
	);
}

export default IndividualApprovalRecordSection;
